var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002E9E",
    d: "m11.12 10.893-1.468 1.005a.554.554 0 0 1-.763-.131A59.917 59.917 0 0 1 6.445 7.97c-.84 1.592-1.602 2.85-2.289 3.804a.554.554 0 0 1-.76.127L1.91 10.886a.527.527 0 0 1-.11-.772c1.347-1.636 2.347-2.69 2.958-3.24a96.493 96.493 0 0 1-4.35-.955.53.53 0 0 1-.381-.68l.57-1.726a.552.552 0 0 1 .709-.337c1.869.662 3.229 1.204 4.117 1.706-.21-1.961-.35-3.384-.395-4.328A.538.538 0 0 1 5.574 0h1.779c.314 0 .564.255.546.56a60.56 60.56 0 0 1-.433 4.322c1.243-.627 2.65-1.175 4.225-1.716a.55.55 0 0 1 .701.34l.582 1.763a.53.53 0 0 1-.355.672c-1.512.456-3.02.754-4.488.933.746.636 1.79 1.728 3.092 3.239.206.24.16.6-.103.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.88234b0571d74e910f1a49914af0b568.svg";
export { ForwardRef as ReactComponent };